import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="label-eyebrow">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  const userRoles = user.roles || [user.role];
  if (roles && !roles.some((r) => userRoles.includes(r))) {
    // Send unauthorized users to their natural home
    const home = user.role === "investor" ? "/marketplace" : "/dashboard";
    return <Navigate to={home} replace />;
  }
  return children;
}
